import React, { PureComponent } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import Transition from 'react-transition-group/Transition';

import './precache.scss';
import Spinner from '../Spinner';

const timeout = 500;

class PreCache extends PureComponent {
  render() {
    return (
      <Transition
        in={this.props.loading}
        timeout={timeout}
        appear
        unmountOnExit
      >
        {(state) =>
          <div className={cn('loading-overlay', state)}>
            <Spinner />
          </div>
        }
      </Transition>
    );
  }
}

PreCache.propTypes = {
  loading: PropTypes.bool.isRequired
};

export default PreCache;



// WEBPACK FOOTER //
// ./src/components/widgets/Precache/index.js